define(["exports", "./pubsubhub"], function (_exports, _pubsubhub) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.run = run;
  _exports.name = void 0;
  // @ts-check
  // Module core/location-hash
  // Resets window.location.hash to jump to the right point in the document
  const name = "core/location-hash";
  _exports.name = name;

  function run() {
    // Added message for legacy compat with Aria specs
    // See https://github.com/w3c/respec/issues/793
    (0, _pubsubhub.pub)("start", "core/location-hash");

    if (!location.hash) {
      return;
    }

    document.respecIsReady.then(() => {
      let hash = decodeURIComponent(location.hash).substr(1);
      const hasLink = document.getElementById(hash);
      const isLegacyFrag = /\W/.test(hash); // Allow some degree of recovery for legacy fragments format.
      // See https://github.com/w3c/respec/issues/1353

      if (!hasLink && isLegacyFrag) {
        const id = hash.replace(/[\W]+/gim, "-").replace(/^-+/, "").replace(/-+$/, "");

        if (document.getElementById(id)) {
          hash = id;
        }
      }

      location.hash = "#".concat(hash);
    });
  }
});
//# sourceMappingURL=location-hash.js.map